import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import { DataService } from "../../Services/dataService";

const SystemSettingsCard = () => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState({
    duty_tax_insurance_percent: "",
    constraint_charge: "",
    dimension_limit_longest: "",
    dimension_limit_total_girth: "",
    minimum_freight: "",
    freight_value_percent: ""
  });

  const fetchSettings = () => {
    setLoader(true);
    DataService.get("/admin/system_settings")
    .then(res => {
      if (res.status && res.data) {
        setData({
          duty_tax_insurance_percent: res.data.duty_tax_insurance_percent || "",
          constraint_charge: res.data.constraint_charge || "",
          dimension_limit_longest: res.data.dimension_limit_longest || "",
          dimension_limit_total_girth: res.data.dimension_limit_total_girth || "",
          minimum_freight: res.data.minimum_freight || "",
          freight_value_percent: res.data.freight_value_percent || ""
        });
      }
      setLoader(false);
    })
    .catch(err => {
      console.error(err);
      setLoader(false);
    });
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    DataService.put("/admin/system_settings", data)
    .then(res => {
      if (res.status) {
        toast.success("System Settings Updated");
      } else {
        toast.error("Error updating settings");
      }
      setLoader(false);
    })
    .catch(err => {
      console.error(err);
      toast.error("Error updating settings");
      setLoader(false);
    });
  };

  return (
    <div className="col-lg-6">
      <div className="card">
        <div className="card-header border-bottom">
          <h4 className="card-title mb-0">Calculation for export docs</h4>
        </div>
        <div className="card-body">
          <form className="control-form" onSubmit={handleSubmit}>
            <div className="row">
              
              <div className="mb-3 col-12">
                <div className="row">
                  <div className="col-6"><label className="form-label">freight for export docs in %</label></div>
                  <div className="col-6">
                    <input type="number" className="form-control" name="freight_value_percent" value={data.freight_value_percent} onChange={handleChange} required />
                  </div>
                </div>
              </div>

              <div className="mb-3 col-12">
                <div className="row">
                  <div className="col-6"><label className="form-label">minimum will be [ value]</label></div>
                  <div className="col-6">
                    <input type="number" className="form-control" name="minimum_freight" value={data.minimum_freight} onChange={handleChange} required />
                  </div>
                </div>
              </div>

            </div>
            <div className="mt-3 d-flex justify-content-between">
              <button className="btn btn-primary w-sm waves-effect waves-light" type="submit">Update Settings</button>
            </div>
          </form>
          <Loader isShow={loader} />
        </div>
      </div>
    </div>
  );
};

export default SystemSettingsCard;
